export default __webpack_public_path__ + "static/media/KZ.М.05.2165 black.5c6c8cbc.svg";